import React, { Component } from 'react';

class ValidationSection extends Component {
  render() {
    const className = this.props.className ? this.props.className : '';
    const hasErrorClass = this.props.errors && this.props.errors.length > 0
      ? 'validation-section--has-errors'
      : '';
    return(
      <div className={`validation-section ${className} ${hasErrorClass}`}>
        {this.props.children}
      </div>
    )
  }
}

export default ValidationSection;
